import { render, staticRenderFns } from "./WarehouseAdd.vue?vue&type=template&id=5b55b67a&scoped=true"
import script from "./WarehouseAdd.vue?vue&type=script&lang=js"
export * from "./WarehouseAdd.vue?vue&type=script&lang=js"
import style0 from "./WarehouseAdd.vue?vue&type=style&index=0&id=5b55b67a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b55b67a",
  null
  
)

export default component.exports